import Promise from 'bluebird';

import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
import last from 'lodash/last';
import map from 'lodash/map';

import { bindActionCreators } from 'redux';
import { SubmissionError} from 'redux-form';

import http from '../../../../../shared/http';
import endpoints from '../../../../../../config/endpoints';

import { actions as parentActions } from '../../../../profile';

export function mapStateToProps(state) {
	const { payoutSettings } = state.affiliateProfile;

	const affiliatePayoutSystemSettings = map(payoutSettings, (payoutSetting) => ({
		id: payoutSetting.id,
		payout_system_id: payoutSetting.payout_system_id,
		credentials: payoutSetting.credentials,
		autoconfirm_settings: payoutSetting.autoconfirm_settings ? {
			max_payout_amount_for_automatic_confirmation:
				String(payoutSetting.autoconfirm_settings.max_payout_amount_for_automatic_confirmation),
			max_payout_number_for_automatic_confirmation:
				String(payoutSetting.autoconfirm_settings.max_payout_number_for_automatic_confirmation)
		} : {
			max_payout_amount_for_automatic_confirmation: '',
			max_payout_number_for_automatic_confirmation: '1'
		},
		is_auto_payout_confirm_enabled: !!payoutSetting.autoconfirm_settings
	}));

	return { initialValues: { affiliatePayoutSystemSettings } };
}

export function mapDispatchToProps(dispatch) {
	return bindActionCreators(actions, dispatch);
}

const FORM_SUBMIT_SUCCESS = 'affiliateProfile/payoutSettingsForm-submit-success';
const FORM_SUBMIT_ERROR = 'affiliateProfile/payoutSettingsForm-submit-error';

const DELETE_SYSTEM_SUCCESS = 'affiliateProfile/payoutSettingsForm-delete-success';

const actions = {
	onSubmit: (values, _, props) => async (dispatch, getState) => {
		const { affiliateId } = getState().affiliateProfile;

		const submissionErrors = {};

		const settings = differenceWith(
			values.affiliatePayoutSystemSettings, props.initialValues.affiliatePayoutSystemSettings, isEqual
		);

		const actions = await Promise.map(settings, async (setting, i) => {
			const request = http({
				url: setting.id
					? endpoints.AFFILIATES.PAYOUT_SETTING
						.replace('{id}', affiliateId)
						.replace('{payout_setting_id}', setting.id)
					: endpoints.AFFILIATES.PAYOUT_SETTINGS
						.replace('{id}', affiliateId),
				method: setting.id ? 'put' : 'post',
				data: {
					payout_system_id: setting.payout_system_id,
					credentials: setting.credentials,
					autoconfirm_settings: setting.is_auto_payout_confirm_enabled ? setting.autoconfirm_settings : null
				},
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR]
			});

			const action = await request(dispatch);

			if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
				const responseErrors = action.payload.response.data;

				forEach(responseErrors, (value) => {
					const key = value.dataPath.slice(1);

					if (key.startsWith('autoconfirm_settings')) {
						submissionErrors.affiliatePayoutSystemSettings = {
							[i]: {
								autoconfirm_settings: {
									[key.split('.')[1]]: value.message
								}
							}
						};
					} else {
						submissionErrors.affiliatePayoutSystemSettings = {
							[i]: {
								credentials: {
									[key]: value.message
								}
							}
						};
					}
				});
			}

			return action;
		});

		if (Object.keys(submissionErrors).length) {
			throw new SubmissionError(submissionErrors);
		}

		if (last(actions).type === FORM_SUBMIT_SUCCESS) {
			dispatch(parentActions.toggleSpinner());
			await dispatch(parentActions.fetchPayoutSettings(affiliateId));
			dispatch(parentActions.toggleSpinner());
		}
	},
	removeSystem: (payoutSettingId, title) => (dispatch, getState) => {
		const { affiliateId } = getState().affiliateProfile;

		if (!window.confirm(`You want to remove "${title}" from affiliate?`)) return ;

		const request = http({
			url: endpoints.AFFILIATES.PAYOUT_SETTING
				.replace('{id}', affiliateId)
				.replace('{payout_setting_id}', payoutSettingId),
			method: 'delete',
			actions: [DELETE_SYSTEM_SUCCESS]
		});

		return request(dispatch)
			.then(async ({ type }) => {
				if (type === DELETE_SYSTEM_SUCCESS) {
					dispatch(parentActions.toggleSpinner());
					await dispatch(parentActions.fetchPayoutSettings(affiliateId));
					dispatch(parentActions.toggleSpinner());
				}
			});
	}
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/index.js